var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9738 10.733V12.69C13.9746 12.8717 13.9374 13.0515 13.8646 13.218C13.7918 13.3845 13.6851 13.5339 13.5512 13.6567C13.4173 13.7795 13.2593 13.873 13.0871 13.9312C12.915 13.9894 12.7327 14.0111 12.5517 13.9947C10.5444 13.7766 8.61616 13.0907 6.92203 11.992C5.34586 10.9905 4.00955 9.65414 3.00798 8.07797C1.90551 6.37614 1.21942 4.43855 1.00529 2.42217C0.988993 2.24177 1.01043 2.05996 1.06825 1.88831C1.12606 1.71665 1.21898 1.55892 1.3411 1.42514C1.46321 1.29137 1.61185 1.18449 1.77753 1.1113C1.94322 1.03812 2.12233 1.00023 2.30345 1.00006H4.26048C4.57706 0.996947 4.88398 1.10906 5.12402 1.31549C5.36407 1.52193 5.52085 1.80861 5.56516 2.12209C5.64776 2.74838 5.80095 3.36332 6.0218 3.95517C6.10957 4.18866 6.12856 4.44241 6.07654 4.68637C6.02451 4.93032 5.90364 5.15425 5.72825 5.33161L4.89977 6.16008C5.82842 7.79325 7.18066 9.14549 8.81382 10.0741L9.6423 9.24566C9.81966 9.07027 10.0436 8.9494 10.2875 8.89737C10.5315 8.84534 10.7852 8.86434 11.0187 8.95211C11.6106 9.17296 12.2255 9.32614 12.8518 9.40874C13.1687 9.45345 13.4581 9.61306 13.665 9.85723C13.8719 10.1014 13.9818 10.4131 13.9738 10.733Z",
    stroke: "#6E6A65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNo);
export default __webpack_public_path__ + "static/media/phone-no.svg";
export { ForwardRef as ReactComponent };